import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { Data, getDataFromApiResponse } from '../../types/data-providers';
import { DeviceChannelData, DevicePropertiesDetails } from '../../types/device';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getDeviceProperties = async (authHelper: AuthHelper, deviceId: string, recursive: boolean) => {
    const deviceDetailsResult = await ApiRequests.getDeviceDetails(
        {
            deviceId: deviceId,
            recursive: recursive,
        },
        { authHelper }
    );

    if (!deviceDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(deviceDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(deviceDetailsResult.response));
    }
    return deviceDetailsResult.response.data.profile;
};

type DeviceConditionData = {
    deviceProperties: Data<DevicePropertiesDetails>;
    channelData: Data<DeviceChannelData[]>;
};

const getDeviceCondition = async (authHelper: AuthHelper, deviceId: string): Promise<DeviceConditionData> => {
    const [deviceDetailsResult, deviceChannelDataResult] = await Promise.all([
        ApiRequests.getDeviceDetails(
            {
                deviceId: deviceId,
                recursive: false,
            },
            { authHelper }
        ),
        ApiRequests.getDeviceChannelData(
            {
                deviceId: deviceId,
            },
            { authHelper }
        ),
    ]);
    if (!deviceDetailsResult.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(deviceDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(deviceDetailsResult.response));
    }
    if (!deviceChannelDataResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(deviceChannelDataResult.response));
    }

    // if (!deviceChannelDataResult.ok) {
    //     throw new Error('Error fetching device information');
    // }
    const deviceProperties = getDataFromApiResponse(deviceDetailsResult, (value) => value.data.profile);
    const channelData = getDataFromApiResponse(deviceChannelDataResult, (value) => value.data.channelData);

    // sort data by channel name
    if (channelData.state === 'Loaded') {
        channelData.value.sort((a, b) => {
            if (a.name !== null && b.name !== null) {
                if (a.name > b.name) return 0;
                if (a.name < b.name) return -1;
            }

            return 0;
        });
    }

    return {
        deviceProperties,
        channelData,
    };
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getStarfishDeviceDetails = async (
    authHelper: AuthHelper,
    deviceId: string
    //siteId: string
) => {
    const starfishDeviceDetailsResult = await ApiRequests.getStarfishDeviceDetails(
        {
            deviceId: deviceId,
            //siteId: siteId,
        },
        { authHelper }
    );

    if (!starfishDeviceDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(starfishDeviceDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(starfishDeviceDetailsResult.response));
    }
    return starfishDeviceDetailsResult.response.data;
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getStarfishChildDeviceDetails = async (
    authHelper: AuthHelper,
    // parentDeviceId: string,
    deviceId: string
    //siteId: string,
    //parentDeviceId: string
) => {
    const starfishChildDeviceDetailsResult = await ApiRequests.getStarfishChildDeviceDetails(
        {
            //parentDeviceId: parentDeviceId,
            deviceId: deviceId,
            //siteId: siteId,
            //parentDeviceId: parentDeviceId,
        },
        { authHelper }
    );

    if (!starfishChildDeviceDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(starfishChildDeviceDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(starfishChildDeviceDetailsResult.response));
    }
    return starfishChildDeviceDetailsResult.response.data;
};

// const getStarfishDeviceCondition = async (
//     authHelper: AuthHelper,
//     deviceId: string,
// ): Promise<DeviceConditionData> => {

//     const [StarfishDeviceDetailsResult] = await Promise.all([
//         ApiRequests.getStarfishDeviceDetails(
//             {
//                 deviceId: deviceId,
//                 //recursive:false
//             },
//             { authHelper }
//         ),
//         // ApiRequests.getDeviceChannelData(
//         //     {
//         //         deviceId: deviceId,
//         //     },
//         //     { authHelper }
//         // ),
//     ]);
//     if (!StarfishDeviceDetailsResult.ok) {
//         console.error(ApiRequests.extractErrorCodeWithMessage(StarfishDeviceDetailsResult.response));
//         throw new Error(ApiRequests.extractErrorCodeWithMessage(StarfishDeviceDetailsResult.response));
//     }
//     // if (!deviceChannelDataResult.ok) {
//     //     console.error(ApiRequests.extractResponseNotOkMessage(deviceChannelDataResult.response));
//     // }

//     // if (!deviceChannelDataResult.ok) {
//     //     throw new Error('Error fetching device information');
//     // }
//     const deviceProperties = getDataFromApiResponse(StarfishDeviceDetailsResult, (value) => value.data.profile);
//     //const channelData = getDataFromApiResponse(deviceChannelDataResult, (value) => value.data.channelData);
//     return {
//         deviceProperties,
//        // channelData,
//     };
// };

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getSierraGatewayDeviceDetails = async (authHelper: AuthHelper, deviceId: string, siteId: string) => {
    const sierraGatewayDeviceDetailsResult = await ApiRequests.getSierraGatewayDeviceDetails(
        {
            pxWhiteGatewayDeviceId: deviceId,
            siteId: siteId,
        },
        { authHelper }
    );

    if (!sierraGatewayDeviceDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(sierraGatewayDeviceDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(sierraGatewayDeviceDetailsResult.response));
    }
    return sierraGatewayDeviceDetailsResult.response.data;
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getSierraChildDeviceDetails = async (
    authHelper: AuthHelper,
    deviceId: string,
    siteId: string,
    childDeviceId: string
) => {
    const sierraChildDeviceDetailsResult = await ApiRequests.getSierraChildDeviceDetails(
        {
            pxWhiteGatewayDeviceId: deviceId,
            siteId: siteId,
            pxWhiteChildDeviceId: childDeviceId,
        },
        { authHelper }
    );

    if (!sierraChildDeviceDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(sierraChildDeviceDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(sierraChildDeviceDetailsResult.response));
    }
    return sierraChildDeviceDetailsResult.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getMeshGatewayDeviceDetails = async (authHelper: AuthHelper, deviceId: string) => {
    const meshGatewayDeviceDetailsResult = await ApiRequests.getMeshGatewayDeviceDetails(
        {
            deviceId: deviceId,
        },
        { authHelper }
    );

    if (!meshGatewayDeviceDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(meshGatewayDeviceDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(meshGatewayDeviceDetailsResult.response));
    }
    return meshGatewayDeviceDetailsResult.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getPartNumberDetails = async (authHelper: AuthHelper, siteId: string) => {
    const getPartNumberDetailsResult = await ApiRequests.getPartNumberDetails(
        {
            siteId: siteId,
        },
        { authHelper }
    );

    if (!getPartNumberDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(getPartNumberDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(getPartNumberDetailsResult.response));
    }
    return getPartNumberDetailsResult.response.data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getSiteSubscriptionDetails = async (authHelper: AuthHelper, siteId: string) => {
    const getSiteSubscriptionDetailsResult = await ApiRequests.getSiteSubscriptionDetails(
        {
            siteId: siteId,
        },
        { authHelper }
    );

    if (!getSiteSubscriptionDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(getSiteSubscriptionDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(getSiteSubscriptionDetailsResult.response));
    }
    return getSiteSubscriptionDetailsResult.response.data;
};

export {
    getDeviceCondition,
    getDeviceProperties,
    getMeshGatewayDeviceDetails,
    getPartNumberDetails,
    getSierraChildDeviceDetails,
    getSierraGatewayDeviceDetails,
    getSiteSubscriptionDetails,
    getStarfishChildDeviceDetails,
    getStarfishDeviceDetails,
};
